import exhibitors from './exhibitors/en';
import visitors from './visitors/en';
import managers from './managers/en';

export default {
  exhibitors,
  visitors,
  managers,
};
